import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, of, switchMap } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AsyncJobType } from '@recruitee/account/data';
import { AsyncJobActions } from '@recruitee/async-job/data';

import { GdprAutoDeleteHttpClient } from './gdpr-auto-delete-http-client';
import { GdprAutoDeleteActions } from './gdpr-auto-delete.store';

@Injectable({ providedIn: 'root' })
export class GdprAutoDeleteEffects {
  public candidatesCounters$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GdprAutoDeleteActions.loadCounter),
      mergeMap(({ payload }) =>
        this.gdprAutoDeleteHttpClient.loadCounter(payload).pipe(
          switchMap(data => [
            GdprAutoDeleteActions.loadCounterSuccess({
              payload: { candidatesCount: data.candidatesCount },
            }),
          ]),
          catchError(error =>
            of(
              GdprAutoDeleteActions.loadCounterFailed({
                payload: { error },
              }),
            ),
          ),
        ),
      ),
    ),
  );

  public autoDelete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GdprAutoDeleteActions.schedule),
      mergeMap(() =>
        this.gdprAutoDeleteHttpClient.schedule().pipe(
          switchMap(({ uuid }) => [
            AsyncJobActions.create({
              payload: { job: { uuid, type: AsyncJobType.AutoDeleteCandidates } },
            }),
            GdprAutoDeleteActions.scheduleSuccess({
              payload: { uuid },
            }),
          ]),
          catchError(error =>
            of(
              GdprAutoDeleteActions.scheduleFailed({
                payload: { error },
              }),
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private gdprAutoDeleteHttpClient: GdprAutoDeleteHttpClient,
  ) {}
}
